import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface UserResponse {
  id: string;
  identifiant: string;
  email: string;
  cle_secrete: string;
  nom_entreprise: string;
  accessLevel: number;
}

@Injectable({
  providedIn: 'root'
})
export class PaymentBackofficeService {

  private getBaseUrl(): string {
    // Dynamically resolve baseUrl to adapt to subdirectory hosting on Apache local server
    const path = "https://dev.sentelecom.com/";
    return path + 'utils/index.php';
  }

  constructor(private http: HttpClient) { }

  private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json'
    });
  }

  // ============ AUTHENTIFICATION ============

  login(credentials: { login: string; password_hash: string }): Observable<any> {
    const url = `${this.getBaseUrl()}/checkAuthentification`;
    const payload = {
      login: credentials.login,
      password: credentials.password_hash
    };
    return this.http.post<any>(url, payload, { headers: this.getHeaders() });
  }


  soppidieufeundikoo(credentials: { login: string; old_password_hash: string, new_password_hash: string }): Observable<any> {
    const url = `${this.getBaseUrl()}/soppidieufeundikoo`;
    const payload = {
      login: credentials.login,
      old_password: credentials.old_password_hash,
      new_password: credentials.new_password_hash
    };
    return this.http.post<any>(url, payload, { headers: this.getHeaders() });
  }

  // ============ TRANSACTIONS ============

  getTransactions(dateDebut: string, dateFin: string): Observable<any> {
    const url = `${this.getBaseUrl()}/getTransactionByUser`;
    const token = sessionStorage.getItem('samacaabiyoonwii') || '';
    const payload = {
      token: token,
      dateDebut: dateDebut,
      dateFin: dateFin
    };
    return this.http.post<any>(url, payload, { headers: this.getHeaders() });
  }


  getSituationCompagnie(dateDebut: string, dateFin: string): Observable<any> {
    const url = `${this.getBaseUrl()}/situationCompagnieByUser`;
    const token = sessionStorage.getItem('samacaabiyoonwii') || '';
    const payload = {
      token: token,
      dateDebut: dateDebut,
      dateFin: dateFin
    };
    return this.http.post<any>(url, payload, { headers: this.getHeaders() });
  }


  
  situationCompagnieActuelleByUser(dateDebut: string, dateFin: string): Observable<any> {
    const url = `${this.getBaseUrl()}/situationCompagnieActuelleByUser`;
    const token = sessionStorage.getItem('samacaabiyoonwii') || '';
    const payload = {
      token: token,
      dateDebut: dateDebut,
      dateFin: dateFin
    };
    return this.http.post<any>(url, payload, { headers: this.getHeaders() });
  }

  // ============ COMMISSIONS ============

  getCommissions(): Observable<any> {
    const url = `${this.getBaseUrl()}/getCommissionnement`;
    const token = sessionStorage.getItem('samacaabiyoonwii') || '';
    const payload = {
      token: token
    };
    return this.http.post<any>(url, payload, { headers: this.getHeaders() });
  }

  updateCommission(id: number, taux: number): Observable<any> {
    const url = `${this.getBaseUrl()}/updateCommissionnement`;
    const token = sessionStorage.getItem('samacaabiyoonwii') || '';
    const payload = {
      token: token,
      id: id,
      taux: taux
    };
    return this.http.post<any>(url, payload, { headers: this.getHeaders() });
  }

}
